import React from 'react';

import { PageTitle } from 'components';
import { Trans, useTranslation } from 'react-i18next';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

export type TeamMemberSignupErrorReason =
  | 'invitationNotFound'
  | 'invitationAlreadyUsed'
  | 'invitationExpired'
  | 'emailAlreadyUsed'
  | 'unkownError';

interface Props {
  errorReason?: TeamMemberSignupErrorReason;
}

const useStyles = createUseStyles((theme: Theme) => ({
  h2: {
    ...theme.fonts.h2,
    marginBottom: theme.marginBase * 2,
  },
  subtitle: {
    ...theme.fonts.body,
  },
  link: {
    ...theme.fonts.label,
    color: theme.colors.blueAccessible,
  },
  alreadyHaveAccount: {
    ...theme.fonts.caption,
    marginTop: theme.marginBase * 5,
    '& > p': {
      marginBottom: theme.marginBase,
    },
  },
}));

export const TeamMemberSignupError = ({ errorReason }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  return (
    <div>
      <PageTitle title={t('signup.metaTitle')} />
      <h2 className={classes.h2}>
        <Trans i18nKey={`signup.error.${errorReason}.title`} />
      </h2>
      <h3 className={classes.subtitle}>
        <Trans i18nKey={`signup.error.${errorReason}.text`} />
      </h3>
    </div>
  );
};
